export const MAIN_MENU_COLLAPSED = "mainMenuCollapsed";
